var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9028 18.7961C24.9028 22.7821 21.6727 26.0122 17.6868 26.0122C13.7008 26.0122 10.4746 22.7821 10.4746 18.7961C10.4746 14.8102 13.7047 11.584 17.6907 11.584C21.6766 11.584 24.9067 14.8141 24.9067 18.8L24.9028 18.7961Z",
    stroke: "#2E75CC",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4278 10.1728C12.7849 9.45587 11.8497 9 10.8094 9C8.86514 9 7.29102 10.5741 7.29102 12.5184C7.29102 13.6756 7.85209 14.7004 8.71318 15.3394C9.58207 13.0834 11.277 11.2404 13.4278 10.1728Z",
    stroke: "#2E75CC",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6677 15.3394C27.5288 14.6965 28.0899 13.6756 28.0899 12.5184C28.0899 10.5741 26.5158 9 24.5715 9C23.5311 9 22.596 9.45587 21.9531 10.1728C24.1039 11.2365 25.7988 13.0834 26.6677 15.3394Z",
    stroke: "#2E75CC",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2374 24.7656L11.3672 28.1516",
    stroke: "#2E75CC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1426 24.7656L24.0128 28.1516",
    stroke: "#2E75CC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5371 16.8379L17.6918 18.7939V22.9591",
    stroke: "#2E75CC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock_icon.e24f08375a7fe653f55542398273e039.svg";
export { ForwardRef as ReactComponent };